import { effect, inject, Injector, runInInjectionContext } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Inverse of authGuard. Used on the landing page, /login, and /signup so that
 * an already-authenticated user is bounced to /dashboard (or the ?redirect=
 * target) instead of being shown marketing or sign-in content.
 */
export const guestGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const injector = inject(Injector);

  const target = route.queryParamMap.get('redirect') ?? '/dashboard';

  if (!auth.isLoading()) {
    return resolve(auth, router, target);
  }

  return new Promise<boolean>((resolveFn) => {
    runInInjectionContext(injector, () => {
      const ref = effect(() => {
        if (auth.isLoading()) return;
        ref.destroy();
        resolveFn(resolve(auth, router, target));
      });
    });
  });
};

function resolve(auth: AuthService, router: Router, target: string): boolean {
  if (!auth.isAuthenticated()) return true;
  void router.navigateByUrl(target);
  return false;
}